module.exports = __webpack_public_path__ + "img/img-badminton.10865249.png";